module.exports = __webpack_public_path__ + "img/img (39).737cbac2.jpg";